import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useParams, useNavigate } from "react-router-dom";
import "./App.css";
import CustomConfirm from "./CustomConfirm";
import asema from "./images/asema.png";
import juna from "./images/junatrain.png";
import redlight from "./images/redlight.png";
import pponstation from "./images/pponstation.png";
import headerbg from "./images/headerbg.png";
import focusontrainarrow from "./images/focusontrainarrow.png";
import beefburgermenu from "./images/beefburgermenu.png";
import beefburgermenuTumma from "./images/beefburgermenuTumma.png";
import someShare from "./images/someshare.png";
import lahtevajuna from "./images/lahtevajuna.png";
import pwaLogo from "./images/logo512.png";
import { StationAd } from "./StationAds";

interface TrainInfoProps {
  trainNumber: number;
}

interface Cause {
  categoryCode: string;
  detailedCategoryCode: string;
  thirdCategoryCode: string;
  categoryCodeId: number;
  detailedCategoryCodeId: number;
  thirdCategoryCodeId: number;
}

interface TimeTableRow {
  stationShortCode: string;
  stationUICCode: number;
  countryCode: string;
  type: string;
  scheduledTime: string;
  actualTime?: string;
  liveEstimateTime?: string;
  differenceInMinutes: number;
  trainStopping: boolean;
  commercialStop: boolean;
  commercialTrack: string;
  cancelled: boolean;
  order: string;
  causes?: Cause[];
}

interface TrainInfo {
  trainNumber: number;
  departureDate: string;
  trainCategory: string;
  trainType: string;
  commuterLineID: string;
  runningCurrently: boolean;
  cancelled: boolean;
  timeTableRows?: TimeTableRow[];
  operatorUICCode: number;
  operatorShortCode: string;
}

interface TrainLocation {
  trainNumber: number;
  departureDate: string;
  timestamp: string;
  location: {
    type: string;
    coordinates: [number, number];
  };
  speed: number;
  accuracy: number;
}

interface StationMetadata {
  stationName: string;
  stationShortCode: string;
  longitude: number;
  latitude: number;
}

interface Train {
  vaihtoasema: string;
  trainNumber: number;
  trainType: string;
  commuterLineID: string;
  destinationStation: string;
  commercialTrack: string;
  cancelled: boolean;
  scheduledTime: string;
  liveEstimateTime: string;
  actualTime: string;
}

type TrainData = {
  vaihtoasema: string;
  trainNumber: string;
  destinationStation: string;
  commercialTrack: string;
  cancelled: boolean;
  scheduledTime: string;
};

interface PassengerInformation {
  id: string;
  trainNumber: number;
  trainDepartureDate: string;
  stations: string[];
  videoTextFi: string;
  videoTextSv: string;
  videoTextEn: string;
  startValidity: string;
  endValidity: string;
}

const TrainInfo: React.FC<TrainInfoProps> = ({ trainNumber }) => {
  const { trainNumber: paramTrainNumber } = useParams<{
    trainNumber: string;
  }>();

  // Convert to a number and set it as the current train number
  const currentTrainNumber = paramTrainNumber
    ? parseInt(paramTrainNumber, 10)
    : trainNumber;

  const [cookiesWindow, setCookiesWindow] = useState(false);
  const [trainInfo, setTrainInfo] = useState<TrainInfo | null>(null);
  const [commercialStops, setCommercialStops] = useState<string[]>([]);
  const [myDestination, setMyDestination] = useState<string>("");
  const [distanceToMyDestination, setDistanceToMyDestination] = useState<
    number | null
  >();
  const [
    scheduledTimeTimeToMyDestination,
    setScheduledTimeTimeToMyDestination,
  ] = useState<string>("");
  const [timeToMyDestination, setTimeToMyDestination] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [departureStation, setDepartureStation] = useState<string | null>(null);
  const [destinationStation, setDestinationStation] = useState<string | null>(
    null,
  );
  const [allStations, setAllStations] = useState<TimeTableRow[]>([]);
  const [stationsMetadata, setStationsMetadata] = useState<StationMetadata[]>(
    [],
  );
  const [stationsWithDistancesAndTimes, setStationsWithDistancesAndTimes] =
    useState<(TimeTableRow & StationMetadata & { distanceToNext: number })[]>(
      [],
    );
  const [speed, setSpeed] = useState<number | null>(null);
  const [mapScale, setMapScale] = useState<number | null>(18);
  const [helperScale, setHelperScale] = useState<number | null>(34);
  const [location, setLocation] = useState<[number, number] | null>(null);

  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const currentTime = new Date();
  const hours = String(currentTime.getHours()).padStart(2, "0"); // Get hours and pad with zero if needed
  const minutes = String(currentTime.getMinutes()).padStart(2, "0"); // Get minutes and pad with zero if needed
  const formattedCurrentTime = `${hours}:${minutes}`;

  const [currentStation, setCurrentStation] = useState<string | null>(null);
  const [mainosStation, setMainosStation] = useState<StationAd[]>([]);
  const [nextStationShortCode, setNextStationShortCode] = useState<
    string | null
  >(null);
  const [stationScheduledTime, setStationScheduledTime] = useState<
    string | null
  >(null);
  const [stationLiveEstimateTime, setStationLiveEstimateTime] = useState<
    string | null
  >(null);
  const [menuOpen, setMenuOpen] = useState(false); // Track menu state
  const [seeTrafficPoints, setSeeTrafficPoints] = useState<boolean>(true);
  const [vaihtojunatHaettu, setvaihtojunatHaettu] = useState<boolean>(false);
  const fetchedStationsRef = useRef(new Set());
  const fetchLockRef = useRef(false);
  const [zIndex, setZIndex] = useState(0);
  const [borderPx, setBorderPx] = useState(0);
  const [stationTrains, setStationTrains] = useState<{
    [key: string]: Train[];
  }>({});
  const [copied, setCopied] = useState(false);
  const [followTrain, setFollowTrain] = useState<boolean>(false);
  const [passengerInformation, setPassengerInformation] = useState<
    PassengerInformation[] | null
  >(null);
  const [deferredPrompt, setDeferredPrompt] = useState<Event | null>(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [moveToTrain, setMoveToTrain] = useState("");
  const [moveToTrainNumber, setMoveToTrainNumber] = useState<number | "">("");
  const [lastLocationUpdate, setLastLocationUpdate] = useState(Date.now());
  const [addedCauses, setAddedCauses] = useState<string[]>([]);
  const [showAddedCauses, setShowAddedCauses] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const cookies = localStorage.getItem("cookieConsent");
    if (cookies) {
      const consentData = JSON.parse(cookies);
      if (consentData.ads === true) {
        import("./StationAds").then((module) => {
          const ads = module.getStationAds(); // Hakee mainoslistan StationAdds.tsx:stä
          setMainosStation(ads);
        });
      }
    }
  }, []);

  useEffect(() => {
    const stopsWithActualTime = trainInfo?.timeTableRows
      ?.filter(
        (row) =>
          allStations.some(
            (station) => station.stationShortCode === row.stationShortCode,
          ) &&
          row.commercialStop && // Kaupallinen pysähdys
          row.type === "ARRIVAL" && // Saapumispysäkki
          row.actualTime, // Saapunut jo, eli actualTime on olemassa
      )
      .sort(
        (a, b) =>
          new Date(b.actualTime!).getTime() - new Date(a.actualTime!).getTime(),
      ); // Järjestetään uusimmasta vanhimpaan

    // Haetaan viimeisin pysäkki, jossa on actualTime, tai null jos sellaista ei ole
    const lastStopWithActualTime = stopsWithActualTime?.[0];

    const current = trainInfo?.timeTableRows
      ?.filter(
        (row) =>
          allStations.some(
            (station) => station.stationShortCode === row.stationShortCode,
          ) &&
          row.type === "DEPARTURE" &&
          row.actualTime, // Vain saapuneet asemat, joilla on actualTime
      )
      .sort(
        (a, b) =>
          new Date(b.actualTime!).getTime() - new Date(a.actualTime!).getTime(),
      )?.[0]; // Järjestetään uusimmasta vanhimpaan // Ota ensimmäinen (uusin)

    setCurrentStation(current?.stationShortCode || null);

    // Etsitään seuraava asema seuraava viimeisimmästä actualtime toteutuneesta rivistä ja ARRIVAL-tyyppisenä
    const nextStation = trainInfo?.timeTableRows?.find(
      (row) =>
        allStations.some(
          (station) => station.stationShortCode === row.stationShortCode,
        ) &&
        row.commercialStop && // Kaupallinen pysähdys
        row.type === "ARRIVAL" && // Asema on saapumispysäkki
        !row.actualTime && // Ei vielä saapunut (ei actualTime-arvoa)
        row.liveEstimateTime &&
        new Date(row.liveEstimateTime) > new Date() &&
        (!lastStopWithActualTime ||
          new Date(row.scheduledTime) >
            new Date(lastStopWithActualTime.scheduledTime)), // Varmistaa, että seuraa viimeisintä actualTime-arvoa
    );

    setNextStationShortCode(nextStation?.stationShortCode || null);
    setStationScheduledTime(nextStation?.scheduledTime || null);
    setStationLiveEstimateTime(nextStation?.liveEstimateTime || null);
  }, [trainInfo, allStations]);

  // Käytetään useEffectia päivittääksemme päivämäärä ja kellonaika
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000); // Päivitä joka sekunti

    return () => clearInterval(timer); // Tyhjennetään intervalli komponentin purkautuessa
  }, []);

  // Call the updateScaleFactor function when commercialStops or stationsMetadata change
  useEffect(() => {
    //updateScaleFactor();
  }, [allStations, stationsMetadata]);

  const formattedDate = currentDateTime
    .toLocaleString("fi-FI", {
      weekday: "long", // Täydellinen viikonpäivä
      year: "numeric", // Vuosi
      month: "2-digit", // Kuukausi kahtena numerona
      day: "2-digit", // Päivä kahtena numerona
    })
    .replace(/(\S+)(na)/i, "$1");

  useEffect(() => {
    setZIndex(9);
  }, []);

  const toggleZIndex = () => {
    setZIndex((prevZIndex) => (prevZIndex === 9 ? 20 : 9));
    setBorderPx((prevBorderPx) => (prevBorderPx === 0 ? 1 : 0));
  };

  const fetchTrainInfo = async () => {
    console.log("fetchTrainInfo");
    try {
      const response = await fetch(
        `https://rata.digitraffic.fi/api/v1/trains/latest/${currentTrainNumber}`,
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data: TrainInfo[] = await response.json();
      if (data.length > 0) {
        const trainData = data[0];

        // Check train type before adding to localStorage
        const validTrainTypes = ["HL", "HLV", "HDM", "PYO", "IC", "S"];
        if (!validTrainTypes.includes(trainData.trainType)) {
          navigate("/set-train-number"); // Redirect to set-train-number page
          return; // Exit the function early
        }

        // Setting trainInfo state
        setTrainInfo(trainData);

        // Check if timeTableRows exists and is an array
        const timetable = trainData.timeTableRows;
        if (Array.isArray(timetable) && timetable.length > 0) {
          const firstStation = timetable[0];
          const lastStation = timetable[timetable.length - 1];

          // Setting departure and destination stations based on timeTableRows
          setDepartureStation(firstStation.stationShortCode);
          setDestinationStation(lastStation.stationShortCode);

          // Kerätään kaikki asemat
          const stops = timetable.map((row) => row);

          //console.log(JSON.stringify(stops, null, 2));

          setAllStations(stops); // Asetetaan pysähdykset

          // Uusi muuttuja kaupallisille pysähdyksille
          const commercialStops = timetable
            .filter(
              (row) => row.type === "ARRIVAL" && row.commercialStop === true,
            )
            .map((row) => row.stationShortCode);

          // Asetetaan kaupalliset pysähdykset (voit käyttää tätä myöhemmin esim. tilassa)
          setCommercialStops(commercialStops);
        } else {
          // Handle the case where timeTableRows is not an array or is empty
          setDepartureStation(null);
          setDestinationStation(null);
        }

        const previousTrains =
          JSON.parse(localStorage.getItem("edellisetJunat") as string) || [];

        // Create the new train entry
        const newTrainEntry = {
          trainNumber: currentTrainNumber,
          trainType:
            trainData.trainType === "HL"
              ? trainData.commuterLineID
              : trainData.trainType,
        };

        // Filter out the existing train number if it exists
        const filteredTrains = previousTrains.filter(
          (train: { trainNumber: number }) =>
            train.trainNumber !== currentTrainNumber,
        );

        // Add the new train entry to the beginning of the array
        const updatedTrains = [newTrainEntry, ...filteredTrains];

        // Keep only the latest unique train numbers and types, limit to the last 14 entries
        const uniqueTrains = Array.from(
          new Map(
            updatedTrains.map((item) => [item.trainNumber, item]),
          ).values(),
        ).slice(0, 6);

        const cookies = localStorage.getItem("cookieConsent");
        if (cookies) {
          const consentData = JSON.parse(cookies);
          if (consentData.personalization === true) {
            localStorage.setItem(
              "edellisetJunat",
              JSON.stringify(uniqueTrains),
            );
          }
        }

        setError(null); // Clear any previous error if the fetch is successful
      } else {
        setError("No train information found");
      }
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Error fetching train info",
      );
    }
  };

  const fetchStationMetadata = async () => {
    console.log("fetchStationMetadata");
    try {
      const response = await fetch(
        `https://rata.digitraffic.fi/api/v1/metadata/stations`,
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data: StationMetadata[] = await response.json();
      const dataWithoutType = (data as any[]).map(({ type, ...rest }) => rest);
      setStationsMetadata(dataWithoutType);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Error fetching station metadata",
      );
    }
  };

  const fetchTrainLocation = async () => {
    console.log("fetchTrainLocation");

    try {
      const response = await fetch(
        `https://rata.digitraffic.fi/api/v1/train-locations/latest/${currentTrainNumber}`,
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data: TrainLocation[] = await response.json();

      if (data.length > 0) {
        const locationData = data[0];
        // Tarkistetaan, että nopeus ei ylitä 200
        const cappedSpeed = Math.min(locationData.speed, 200);
        setLastLocationUpdate(Date.now());
        setSpeed(cappedSpeed);
        setLocation(locationData.location.coordinates);
      } else {
        setSpeed(null);
        setLocation(null);
      }
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Error fetching train location",
      );
    }
  };

  const fetchPassengerInformation = async () => {
    console.log("fetchPassengerInformation");

    try {
      const response = await fetch(
        `https://rata.digitraffic.fi/api/v1/passenger-information/active?station=${nextStationShortCode}`,
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      // Suodatetaan vain ne junat, joiden trainNumber vastaa currentTrainNumberia
      const filteredTrainData = data
        .filter((train: { trainNumber: string }) => {
          return parseInt(train.trainNumber, 10) === currentTrainNumber;
        })
        .map(
          (train: {
            id: any;
            trainNumber: any;
            trainDepartureDate: any;
            stations: any;
            video: { text: { fi: any; sv: any; en: any } };
            startValidity: any;
            endValidity: any;
          }) => ({
            id: train.id, // Merkkijono
            trainNumber: train.trainNumber, // Numero
            trainDepartureDate: train.trainDepartureDate,
            stations: train.stations, // Taulukko
            videoTextFi: train.video.text.fi, // Suomi
            videoTextSv: train.video.text.sv, // Ruotsi
            videoTextEn: train.video.text.en, // Englanti
            startValidity: train.startValidity, // Merkkijono
            endValidity: train.endValidity, // Merkkijono
          }),
        );

      if (filteredTrainData.length > 0) {
        setPassengerInformation(filteredTrainData);
      } else {
        setPassengerInformation(null); // Ei löytynyt vastaavia junia
      }
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Error fetching passenger information",
      );
    }
  };

  const fetchStationPassingTrains = async (
    stationShortCode: string,
    scheduledTime: string,
  ) => {
    console.log("fetchStationPassingTrains");

    try {
      const response = await fetch(
        `https://rata.digitraffic.fi/api/v1/live-trains/station/${stationShortCode}?minutes_before_departure=900&minutes_after_departure=300&minutes_before_arrival=0&minutes_after_arrival=0&train_categories=Commuter,Long-distance`,
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      // Haetaan HKI:n koordinaatit, jotta voidaan laskea etäisyys
      const hkiStation = stationsMetadata.find(
        (station) => station.stationShortCode === "HKI",
      );

      if (!hkiStation) {
        console.error("Helsinki station data not found");
        return;
      }

      const hkiCoordinates: [number, number] = [
        hkiStation.longitude,
        hkiStation.latitude,
      ];

      const startTime = new Date(scheduledTime).getTime();
      const endTime = startTime + 60 * 60 * 1000; // 1 tunti myöhemmin

      // Suodatetaan data
      const filteredTrains = data.flatMap((train: any) => {
        // Etsitään viimeinen ARRIVAL asema (määränpää)
        const lastArrivalStation = train.timeTableRows
          .filter((row: any) => row.type === "ARRIVAL")
          .pop(); // Hakee viimeisen ARRIVAL-tyypin rivin

        // Jos lastArrivalStation löytyy, lisätään se määränpääksi
        const destinationStation = lastArrivalStation
          ? lastArrivalStation.stationShortCode
          : "Unknown"; // Jos määränpäätä ei löydy, laita "Unknown"

        // Lasketaan etäisyys lähtöaseman ja HKI:n välillä
        const station = stationsMetadata.find(
          (station) => station.stationShortCode === stationShortCode,
        );

        if (!station) {
          console.error(`Station ${stationShortCode} not found`);
          return [];
        }

        const stationCoordinates: [number, number] = [
          station.longitude,
          station.latitude,
        ];
        const distance = calculateLocationDistance(
          stationCoordinates,
          hkiCoordinates,
        );

        let validTrains = [];
        if (distance < 60) {
          // Suodatetaan pois HL ja HLV, jos etäisyys on alle 60 km
          validTrains = train.timeTableRows
            .filter(
              (row: any) =>
                row.stationShortCode === stationShortCode &&
                row.type === "DEPARTURE" &&
                new Date(row.scheduledTime).getTime() > startTime &&
                new Date(row.scheduledTime).getTime() <= endTime &&
                train.trainType !== "HV" &&
                !(train.trainType === "HL" || train.trainType === "HLV"), // Suodatetaan pois HL ja HLV
            )
            .map((row: any) => ({
              vaihtoasema: stationShortCode,
              trainNumber: train.trainNumber, // Junan numero
              trainType: train.trainType,
              commuterLineID: train.commuterLineID,
              destinationStation, // Määränpää
              commercialTrack: row.commercialTrack,
              cancelled: row.cancelled,
              scheduledTime: row.scheduledTime,
              liveEstimateTime: row.liveEstimateTime,
              actualTime: row.actualTime,
            }));
        } else {
          validTrains = train.timeTableRows
            .filter(
              (row: any) =>
                row.stationShortCode === stationShortCode &&
                row.type === "DEPARTURE" &&
                new Date(row.scheduledTime).getTime() > startTime &&
                new Date(row.scheduledTime).getTime() <= endTime &&
                train.trainType !== "HV" &&
                train.trainType !== "MV", // Suodatetaan pois "HV" ja "MV" -tyyppiset junat
            )
            .map((row: any) => ({
              vaihtoasema: stationShortCode,
              trainNumber: train.trainNumber, // Junan numero
              trainType: train.trainType,
              commuterLineID: train.commuterLineID,
              destinationStation, // Määränpää
              commercialTrack: row.commercialTrack,
              cancelled: row.cancelled,
              scheduledTime: row.scheduledTime,
              liveEstimateTime: row.liveEstimateTime,
              actualTime: row.actualTime,
            }));
        }

        return validTrains;
      });

      // Järjestetään junat scheduledTime kentän mukaan aikajärjestykseen
      filteredTrains.sort(
        (a: any, b: any) =>
          new Date(a.scheduledTime).getTime() -
          new Date(b.scheduledTime).getTime(),
      );

      // Asetetaan suodatetut ja järjestetyt junat tilaan
      setStationTrains((prevTrains) => ({
        ...prevTrains,
        [stationShortCode]: filteredTrains, // Liitetään junatiedot oikealle asemalle
      }));
    } catch (err) {
      console.error(
        err instanceof Error ? err.message : "Error fetching train data",
      );
    }
    setvaihtojunatHaettu(true);
  };

  const groupTimeTableRows = (timeTableRows?: TimeTableRow[]) => {
    const groupedRows = new Map<string, TimeTableRow[]>();

    timeTableRows?.forEach((row) => {
      const stationCode = row.stationShortCode;
      if (!groupedRows.has(stationCode)) {
        groupedRows.set(stationCode, []);
      }
      groupedRows.get(stationCode)?.push(row);
    });

    return groupedRows;
  };

  useEffect(() => {
    fetchStationMetadata();
    setCurrentStation(departureStation);
    fetchTrainLocation();
    const interval = setInterval(fetchTrainLocation, 60000); // Päivitä sijainti 1 min välein
    // Tarkista 30 sekunnin aikaraja ja aseta nopeus null, jos ei ole päivitystä
    const timeout = setTimeout(() => {
      if (Date.now() - lastLocationUpdate > 30000) {
        setSpeed(null);
        setLocation(null);
      }
    }, 30000);

    // Siivous funktiot, kun komponentti poistuu
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [currentTrainNumber]);

  useEffect(() => {
    fetchTrainInfo();
    const intervalId = setInterval(() => {
      fetchTrainInfo();
    }, 60000); // 60000 ms = 1 minuutti
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setvaihtojunatHaettu(false);
    }, 600000); // 60000 ms = 10 minuutti
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    fetchPassengerInformation();
  }, [nextStationShortCode]);

  useEffect(() => {
    if (error) {
      const retryTimeout = setTimeout(() => {
        fetchTrainInfo(); // Yritetään hakea tietoja uudelleen
      }, 2000); // 2 sekuntia

      return () => clearTimeout(retryTimeout);
    }
  }, [error]);

  const handleCopyUrl = () => {
    const pageUrl = `https://minunjunani.fi/${currentTrainNumber}`;

    // Yritetään kopioida URL leikepöydälle
    navigator.clipboard
      .writeText(pageUrl)
      .then(() => {
        setCopied(true); // Asetetaan 'copied' true:ksi, jolloin teksti muuttuu
        setTimeout(() => setCopied(false), 6000); // Palautetaan tila takaisin 'false' 6 sekunnin kuluttua
      })
      .catch((error) => {
        console.error("Linkin kopiointi epäonnistui", error);
        alert("Linkin kopiointi epäonnistui"); // Virheilmoitus, jos kopiointi epäonnistuu
      });
  };

  const stationNames: { [key: string]: string } = {
    AHO: "Ahonpää",
    AHV: "Ahvenus",
    AIN: "Ainola",
    ARL: "Airaksela",
    ATL: "Aittaluoto",
    AJO: "Ajos",
    APT: "Alapitkä",
    ALV: "Alavus",
    ALH: "Alholma",
    ARO: "Arola",
    ASO: "Asola",
    AVP: "Aviapolis",
    BSL: "Buslovskaja",
    DRA: "Dragsvik",
    DMV: "Dynamiittivaihde",
    EPZ: "Eläinpuisto-Zoo",
    ENO: "Eno",
    ERV: "Ervelä",
    ELA: "Eskola",
    EPO: "Espoo",
    HPJ: "Haapajärvi",
    HPS: "Haapakoski",
    HPK: "Haapamäki",
    HPA: "Haaparanta",
    HAA: "Haarajoki",
    HLT: "Hakosilta",
    HSI: "Haksi",
    HMA: "Hamina",
    HSL: "Hammaslahti",
    HNA: "Hanala",
    HGS: "Hangonsaari",
    HNH: "Hanhikoski",
    HKS: "Hankasalmi",
    HNK: "Hanko",
    HNKT: "Hanko tavara",
    HKP: "Hanko-Pohjoinen",
    HVA: "Harjavalta",
    HJ: "Harju",
    HRV: "Harviala",
    HD: "Haukipudas",
    HAU: "Haukivuori",
    HAS: "Hausjärvi tavara",
    HVS: "Haviseva",
    HVK: "Havukoski",
    HEK: "Heikkilä",
    HA: "Heinola",
    HNO: "Heinoo",
    HÄV: "Heinävaara",
    HNV: "Heinävesi",
    HKI: "Helsinki",
    KHK: "Helsinki Kivihaka",
    HNN: "Henna",
    HR: "Herrala",
    HKH: "Hiekkaharju",
    HIR: "Hiirola",
    HK: "Hikiä",
    HLS: "Hillosensalmi",
    HH: "Hinthaara",
    HVN: "Hirvineva",
    HP: "Humppila",
    HPL: "Huopalahti",
    HKO: "Huutokoski",
    HYR: "Hyrkäs",
    HYS: "Hyrynsalmi",
    HY: "Hyvinkää",
    PVL: "Hyvinkää Paavola",
    HYT: "Hyvinkää tavara",
    HL: "Hämeenlinna",
    HM: "Härmä",
    HÖL: "Höljäkkä",
    II: "Ii",
    ITR: "Iisalmen teollisuusraiteet",
    ILM: "Iisalmi",
    R983: "Iisalmi (R983)",
    ITA: "Iittala",
    ILA: "Ilmala",
    ILR: "Ilmala ratapiha",
    IOA: "Ilola",
    ILO: "Ilomantsi",
    IMR: "Imatra",
    IMT: "Imatra tavara",
    IMK: "Imatrankoski",
    IMKR: "Imatrankoski-raja",
    IM: "Immola",
    IN: "Inha",
    IKR: "Inkeroinen",
    IKO: "Inkoo",
    IKY: "Isokyrö",
    JAL: "Jalasjärvi",
    JPA: "Jepua",
    JNS: "Joensuu",
    KPP: "Joensuu Koppola",
    PLT: "Joensuu Peltola",
    SUL: "Joensuu Sulkulahti",
    JK: "Jokela",
    JOR: "Joroinen",
    JRS: "Jorvas",
    JTS: "Joutseno",
    JKI: "Juankoski",
    JUT: "Jutila",
    JJ: "Juupajoki",
    JRI: "Juurikorpi",
    JY: "Jyväskylä",
    JÄS: "Jämsä",
    JSK: "Jämsänkoski",
    JR: "Järvelä",
    JP: "Järvenpää",
    KPA: "Kaipiainen",
    KLA: "Kaipola",
    KJR: "Kaitjärvi",
    KAJ: "Kajaani",
    KTN: "Kaleton",
    KAU: "Kalkku",
    KAO: "Kalliovarasto",
    KSA: "Kalvitsa",
    KGS: "Kangas",
    KAN: "Kannelmäki",
    KSI: "Kannonkoski",
    KNS: "Kannus",
    KRR: "Karhejärvi",
    KHG: "Karhukangas",
    KR: "Karjaa",
    KRU: "Karkku",
    KAR: "Karviainen",
    KSK: "Kaskinen",
    KTH: "Kattilaharju",
    KJI: "Kauhajoki",
    KHA: "Kauhava",
    KLH: "Kauklahti",
    KLR: "Kaulinranta",
    KNI: "Kauniainen",
    KPL: "Kauppilanmäki",
    KA: "Kausala",
    KTP: "Keitelepohja",
    KEK: "Kekomäki",
    KEM: "Kemi",
    LI: "Kemi Lautiosaari",
    SHS: "Kemi Sahansaari",
    KJÄ: "Kemijärvi",
    KML: "Kempele",
    KEA: "Kera",
    R660: "Kerava (R660)",
    KE: "Kerava",
    KIÄ: "Kerimäki",
    KTI: "Kesälahti",
    KEU: "Keuruu",
    KIA: "Kiiala",
    KIL: "Kilo",
    KUA: "Kilpua",
    KNH: "Kinahmi",
    KII: "Kinni",
    KIJ: "Kirjola",
    KKN: "Kirkkonummi",
    KRN: "Kirkniemi",
    KIT: "Kitee",
    KN: "Kiukainen",
    KRV: "Kiuruvesi",
    KVJ: "Kivesjärvi",
    KIV: "Kivijärvi",
    KTÖ: "Kivistö",
    KOH: "Kohtavaara",
    KVU: "Koivu",
    KVH: "Koivuhovi",
    KVY: "Koivukylä",
    KKI: "Kokemäki",
    KOK: "Kokkola",
    KLI: "Kolari",
    KLO: "Kolho",
    KPI: "Kolppi",
    KMM: "Kommila",
    KOM: "Komu",
    KHI: "Kontiolahti",
    KON: "Kontiomäki",
    R934: "Kontiomäki (R934)",
    KRA: "Koria",
    KAS: "Korkeakoski",
    KRS: "Korso",
    KSU: "Korvensuo",
    KOS: "Koskenkorva",
    KTA: "Kotka",
    HOS: "Kotka Hovinsaari",
    MSS: "Kotka Mussalo",
    KTT: "Kotka tavara",
    KTS: "Kotkan satama",
    KOO: "Kotolahti",
    KV: "Kouvola",
    KVLA: "Kouvola lajittelu",
    OIK: "Kouvola Oikoraide",
    KVT: "Kouvola tavara",
    KOI: "Kovjoki",
    KPY: "Kruunupyy",
    KIS: "Kuivasjärvi",
    KUV: "Kullasvaara",
    KUO: "Kuopio",
    ILH: "Kuopio Iloharju",
    KUOT: "Kuopio tavara",
    KUT: "Kupittaa",
    KRM: "Kurkimäki",
    KU: "Kuurila",
    KUK: "Kuusankoski",
    KSN: "Kuusikkoniemi",
    KYN: "Kylänlahti",
    KY: "Kymi",
    KLN: "Kyminlinna",
    KÖ: "Kyrö",
    KYT: "Kytömaa",
    KLV: "Kälviä",
    KÄP: "Käpylä",
    KÖK: "Köykkäri",
    LAV: "Laajavuori",
    LPR: "Lahdenperä",
    LHN: "Lahnaslampi",
    LH: "Lahti",
    LAI: "Laihia",
    LAK: "Lakiala",
    LMK: "Lamminkoski",
    LAM: "Lamminniemi",
    LPJ: "Lapinjärvi",
    LNA: "Lapinlahti",
    LR: "Lappeenranta",
    LAA: "Lappila",
    LPO: "Lappohja",
    LPA: "Lapua",
    LYÖ: "Larvakytö",
    LAU: "Laukaa",
    LLA: "Laurila",
    LRS: "Lauritsala",
    LNÄ: "Leinelä",
    LKL: "Lelkola",
    LPÄ: "Lempäälä",
    LEN: "Lentoasema",
    LK: "Leppäkoski",
    LPV: "Leppävaara",
    LTS: "Leteensuo",
    LIS: "Lieksa",
    LTK: "Lieksan teollisuuskylä",
    LLH: "Lielahti",
    LVT: "Lievestuore",
    LKA: "Liminka",
    LMP: "Liminpuro",
    LUO: "Lohiluoma",
    LO: "Lohja",
    LM: "Loimaa",
    LOH: "Louhela",
    LOL: "Loukolampi",
    LVS: "Loviisan satama",
    LUI: "Luikonlahti",
    LUS: "Lusto",
    LÄ: "Luumäki",
    LHS: "Lähessuo",
    LÄP: "Länkipohja",
    MLK: "Maanselkä",
    MRI: "Maaria",
    MD: "Madesjärvi",
    MJJ: "Majajärvi",
    MKN: "Maksniemi",
    ML: "Malmi",
    MLO: "Malminkartano",
    MKA: "Mankala",
    MRK: "Markkala",
    MRL: "Martinlaakso",
    MAS: "Masala",
    MTV: "Matkaneva",
    MAT: "Mattila",
    MLL: "Melalahti",
    MSÄ: "Metsäkansa",
    MI: "Mikkeli",
    MIS: "Misi",
    MLA: "Mommila",
    MVA: "Moskova_(Leningradski)",
    MH: "Muhos",
    MUK: "Mukkula",
    MUR: "Murtomäki",
    MSO: "Mustio",
    MST: "Mustolan satama",
    MKO: "Muukko",
    MUU: "Muurame",
    MUL: "Muurola",
    MYS: "Myllykangas",
    MKI: "Myllykoski",
    MY: "Myllymäki",
    MYL: "Myllyoja",
    MYT: "Mynttilä",
    MYN: "Mynämäki",
    MYR: "Myyrmäki",
    MÄK: "Mäkkylä",
    MLÄ: "Mäntsälä",
    MÄN: "Mänttä",
    MR: "Mäntyharju",
    MN: "Mäntyluoto",
    MN_V: "Mäntyluoto erkanemisvaihde",
    NNL: "Naantali",
    NRI: "Naarajärvi",
    NAL: "Nakkila",
    NSL: "Nastola",
    NMP: "Niemenpää",
    NII: "Niinimaa",
    NMÄ: "Niinimäki",
    NNS: "Niinisalo",
    NRL: "Niirala",
    NRLR: "Niirala-raja",
    NTH: "Niittylahti",
    NLÄ: "Nikkilä",
    NSK: "Niska",
    NVL: "Nivala",
    NOA: "Nokia",
    NM: "Nummela",
    NUA: "Nuojua",
    NRM: "Nurmes",
    NÄR: "Närpiö",
    OHM: "Ohenmäki",
    OI: "Oitti",
    OLLI: "Olli",
    ONT: "Onttola",
    OM: "Orimattila",
    OV: "Orivesi",
    OVK: "Orivesi keskusta",
    OTM: "Otanmäki",
    OT: "Otava",
    OU: "Oulainen",
    OL: "Oulu",
    NOK: "Oulu Nokela",
    ORI: "Oulu Oritkari",
    OLT: "Oulu tavara",
    TUA: "Oulu Tuira",
    OLK: "Oulunkylä",
    OLL: "Oulunlahti",
    PTI: "Paimenportti",
    PO: "Paimio",
    PLP: "Palopuro",
    PTO: "Paltamo",
    PAS: "Pankakoski",
    PAR: "Parikkala",
    PKO: "Parkano",
    PRL: "Parola",
    PSL: "Pasila",
    PAU: "Pasila autojuna-asema",
    PSLT: "Pasila tavara",
    PTG: "Patokangas",
    PA: "Pelkola",
    PEL: "Pello",
    PMI: "Peltosalmi",
    PSJ: "Peräseinäjoki",
    PSK: "Pesiökylä",
    PRK: "Petroskoi / Petrozavodsk",
    PVI: "Petäjävesi",
    PM: "Pieksämäki",
    PMLA: "Pieksämäki lajittelu",
    PMT: "Pieksämäki tavara",
    TMU: "Pieksämäki Temu",
    PTR: "Pietari_(Finljandski)",
    PTL: "Pietari_(Ladozhski)",
    PTS: "Pietarsaari",
    PH: "Pihlajavesi",
    PP: "Pihtipudas",
    PIK: "Piikkiö",
    PKL: "Pikkarala",
    PIO: "Pitkäkallio",
    PTK: "Pitkämäki",
    PJM: "Pitäjänmäki",
    PKU: "Pohjankuru",
    POH: "Pohjois-Haaga",
    PLU: "Pohjois-Louko",
    PKK: "Poikkeus",
    POI: "Poiksilta",
    PRI: "Pori",
    PRV: "Porvoo",
    PUS: "Puhos",
    PLA: "Puistola",
    PMK: "Pukinmäki",
    PL: "Pulsa",
    PUN: "Punkaharju",
    PUR: "Purola",
    PYK: "Pyhäkumpu",
    PYE: "Pyhäkumpu erkanemisvaihde",
    PHÄ: "Pyhäsalmi",
    PNÄ: "Pietarsaari-Pännäinen",
    R855: "Pännäinen (R855)",
    PKY: "Pääskylahti",
    RHE: "Raahe",
    RPO: "Raippo",
    RAI: "Raisio",
    RM: "Rajamäki",
    RJP: "Rajaperkiö",
    RMI: "Rantasalmi",
    RAS: "Rasinsuo",
    RLÄ: "Ratikylä",
    RAH: "Rauha",
    RHL: "Rauhalahti",
    RMA: "Rauma",
    RIO: "Raunio",
    RAT: "Rautaruukki",
    RJÄ: "Rautjärvi",
    RPH: "Rautpohja",
    RKL: "Rekola",
    REE: "Retretti",
    R060: "Riihimäki (R060)",
    R702: "Riihimäki (R702)",
    ARP: "Riihimäki Arolampi",
    RI: "Riihimäki",
    RILA: "Riihimäki lajittelu",
    RIT: "Riihimäki tavara",
    RJR: "Riijärvi",
    RPA: "Riippa",
    RST: "Ristiina",
    RJV: "Ristijärvi",
    ROI: "Rovaniemi",
    RHA: "Ruha",
    RNN: "Runni",
    RSU: "Ruokosuo",
    RKI: "Ruukki",
    RSM: "Ruusumäki",
    RY: "Ryttylä",
    RÖY: "Röyttä",
    SAA: "Saakoski",
    SR: "Saari",
    SRJ: "Saarijärvi",
    SLN: "Salminen",
    SLO: "Salo",
    SAM: "Sammalisto",
    STA: "Santala",
    SAU: "Saunakallio",
    SMÄ: "Saunamäki",
    SAV: "Savio",
    SL: "Savonlinna",
    SK: "Seinäjoki",
    RLA: "Seinäjoki Rahkola",
    SKT: "Seinäjoki tavara",
    SPÄ: "Selänpää",
    SPJ: "Sieppijärvi",
    SVI: "Sievi",
    SKÄ: "Siikamäki",
    SIJ: "Siilinjärvi",
    SIM: "Simo",
    SPL: "Simpele",
    SIP: "Sipilä",
    STÖ: "Sisättö",
    STI: "Siuntio",
    SIU: "Siuro",
    SGY: "Skogby",
    SLD: "Sköldvik",
    SOA: "Soinlahti",
    SOR: "Sorsasalo",
    SKV: "Sukeva",
    SUO: "Suolahti",
    SNJ: "Suonenjoki",
    SNM: "Suoniemi",
    STG: "Svetogorsk",
    SYR: "Syrjä",
    SKI: "Syrjämäki",
    SMJ: "Sysmäjärvi",
    SÄ: "Säkäniemi",
    SKM: "Sänkimäki",
    SJ: "Sääksjärvi",
    TA: "Taavetti",
    TKO: "Tahkoluoto",
    TE: "Taipale",
    TV: "Talviainen",
    TLV: "Talvivaara",
    TMS: "Tammisaari",
    TPE: "Tampere",
    JVS: "Tampere Järvensivu",
    TPET: "Tampere tavara",
    VKA: "Tampere Viinikka",
    TNA: "Tapanila",
    TAP: "Tapavainola",
    TSL: "Tavastila",
    TK: "Tervajoki",
    TRV: "Tervola",
    TSO: "Tesoma",
    TUV: "Teuva",
    TKK: "Tikkala",
    TKP: "Tikkaperä",
    TKL: "Tikkurila",
    TOH: "Tohmajärvi",
    TL: "Toijala",
    TOI: "Toivala",
    TOL: "Tolsa",
    TOM: "Tommola",
    TRK: "Torkkeli",
    R742: "Tornio (R742)",
    TOR: "Tornio",
    TRI: "Tornio-Itäinen",
    TRR: "Tornio-raja",
    TRL: "Tuomarila",
    TJA: "Tuomioja",
    R530: "Tuomioja (R530)",
    TU: "Turenki",
    TKU: "Turku",
    TUS: "Turku satama",
    TKUT: "Turku tavara",
    TPV: "Tuupovaara",
    TUU: "Tuuri",
    TVE: "Tver",
    TÖR: "Törmä",
    TRÄ: "Törölä",
    UIM: "Uimaharju",
    UR: "Urjala",
    UTJ: "Utajärvi",
    UTI: "Utti",
    UKP: "Uusikaupunki",
    UKÄ: "Uusikylä",
    VKO: "Vaajakoski",
    VAA: "Vaala",
    VRA: "Vaarala",
    VS: "Vaasa",
    VJR: "Vahojärvi",
    VNA: "Vainikkala",
    VNAT: "Vainikkala tavara",
    VNAR: "Vainikkala-raja",
    VMO: "Valimo",
    VI: "Valkeakoski",
    VSO: "Valkeasuo",
    VLM: "Valtimo",
    VMA: "Vammala",
    VTR: "Vanattara",
    VKS: "Vantaankoski",
    VAR: "Varkaus",
    VUS: "Vartius",
    VUR: "Vartius-raja",
    VKH: "Vasikkahaka",
    VSK: "Vaskiluoto",
    VEH: "Vehkala",
    VKI: "Venetmäki",
    VN: "Vesanka",
    VK: "Viekki",
    VRM: "Vierumäki",
    VTI: "Vihanti",
    VIH: "Vihtari",
    VRI: "Vihtavuori",
    VIA: "Viiala",
    VNJ: "Viinijärvi",
    VYB: "Viipuri",
    VLH: "Villähde",
    VLP: "Vilppula",
    VIN: "Vinnilä",
    VMS: "Virkamies",
    VT: "Voltti",
    VHJ: "Vuohijärvi",
    VJO: "Vuojoki",
    VKT: "Vuokatti",
    VSL: "Vuonislahti",
    VNS: "Vuonos",
    VSA: "Vuosaari",
    VRS: "Värtsilä",
    YKST: "Ykspihlaja tavara",
    YKSV: "Ykspihlaja väliratapiha",
    YST: "Ylistaro",
    YTR: "Ylitornio",
    YLV: "Ylivalli",
    YV: "Ylivieska",
    YLK: "Yläkoski",
    YLY: "Ylämylly",
    YLÖ: "Ylöjärvi",
    YPY: "Ypykkävaara",
    ÄS: "Äetsä",
    ÄHT: "Ähtäri",
    ÄM: "Ämmänsaari",
    ÄKI: "Äänekoski",
  };

  const syyKoodit: { [key: string]: string } = {
    A1: "Mäkeenjäänti tai nopeuden poikkeuksellinen aleneminen mäessä",
    A2: "Aikataulusuunnittelun virhe",
    A3: "Junaa ei ole ajettu",
    E1: "Etuajassa lähtö",
    E2: "Ajo- tai pysähtymisajan alitus",
    I1: "Poikkeukselliset sääolosuhteet",
    I2: "Lehtikeli tai muu liukkaus",
    I3: "Ilkivalta, asiaton radalla liikkuminen",
    I4: "Muu syy",
    J1: "Junan muodostamisen viivästyminen (kaikki liikenne)",
    K1: "Kalustopula",
    K2: "Kalustovika",
    K3: "Kalustosta johtuva nopeuden alennus",
    K4: "Kytkentä",
    K5: "Irroitus",
    K6: "Katsastamaton kalusto",
    L1: "Yhteysliikenteen odotus (jatkoyhteydet)",
    L2: "Junakohtaus, edellä kulkeva juna tai ohitus",
    L3: "Konflikti kapasiteetissa",
    L4: "Myöhästyminen ulkomailta",
    L5: "Edessä oleva kalusto tukkii radan",
    L6: "Junan lähtöön liittyvä odotus",
    L7: "Liikenteenhoitovirhe",
    L8: "Liikenteelliset päätökset",
    M1: "Matkustajajunan pysähtymisajan ylitys",
    M2: "Ylimääräinen pysähdys",
    O1: "Allejäänti (ihminen)",
    O2: "Allejäänti (eläin)",
    O3: "Tasoristeysonnettomuus",
    O4: "Muut onnettomuudet ja vauriot",
    P1: "Ratainfran laiteviat",
    P2: "Tietojärjestelmäviat",
    P3: "Liikkuvan kaluston valvontalaitevika tai -häiriö",
    P4: "Viestintälaite /-yhteysviat",
    R1: "Ratatyöt (ennakoidut työt nopeusrajoituksineen)",
    R2: "Ratatyön sovitun ajan ylitys",
    R3: "Liikennerajoite ratatyön jälkeen",
    R4: "Ratatyön toteutus poikkeaa suunnitellusta",
    S1: "Sähkönjakeluhäiriö",
    S2: "Sähköratavika",
    T1: "Pitkäaikaiset nopeusrajoitukset",
    T2: "Liikenteenohjauksen asettamat nopeusrajoitukset (ratarakenne)",
    T3: "Ratarikko / este radalla",
    V1: "Veturipula",
    V2: "Veturivika",
    V3: "Vetovoimasta johtuva nopeuden alennus / tehon puute",
    V4: "Katsastamaton vetokalusto",
  };

  const handleClickTrain = (
    trainType: string,
    trainNumber: number,
    destinationStation: string,
  ) => {
    setMoveToTrainNumber(trainNumber);
    setMoveToTrain(
      `${trainType} ${trainNumber} ${stationNames[destinationStation]}`,
    );
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    window.location.href = `/${moveToTrainNumber}`;
  };

  const handleCancel = () => {
    setShowConfirm(false);
  };

  const formatDateOnlyDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };
    const formattedDate = new Date(dateString).toLocaleDateString(
      "fi-FI",
      options,
    );
    return formattedDate.replace(/(\S+)(na)/i, "$1");
  };

  const calculateLocationDistance = (
    start: [number, number],
    end: [number, number],
  ) => {
    const toRadians = (angle: number) => (angle * Math.PI) / 180;

    const R = 6371; // Maa säde kilometreinä
    const dLat = toRadians(end[1] - start[1]);
    const dLon = toRadians(end[0] - start[0]);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(start[1])) *
        Math.cos(toRadians(end[1])) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Palautetaan etäisyys kilometreinä
  };

  const calculateDistance = (
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
  ): number => {
    const R = 6371; // Maapallon säde kilometreinä
    const dLat = (lat2 - lat1) * (Math.PI / 180); // Muutetaan asteet radiaaneiksi
    const dLon = (lon2 - lon1) * (Math.PI / 180);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Etäisyys kilometreinä
  };

  const toggleInfo = () => {
    if (showAddedCauses) {
      setShowAddedCauses(false);
    } else {
      setShowAddedCauses(true);
    }
  };

  useEffect(() => {
    // Function to compute distances and augment stations
    const computeStationsWithDistances = () => {
      const stationsWithCoordinates = allStations
        .map((stop) => {
          const station = stationsMetadata.find(
            (s) => s.stationShortCode === stop.stationShortCode,
          );

          if (!station) {
            return null; // If the station isn't found
          }

          return {
            ...stop,
            latitude: station.latitude,
            longitude: station.longitude,
          };
        })
        .filter(Boolean) as (TimeTableRow & {
        latitude: number;
        longitude: number;
      })[];

      const stationsWithDistances = stationsWithCoordinates
        .map((currentStop, index) => {
          if (!currentStop) {
            return null; // Handle null case
          }

          const nextStop = stationsWithCoordinates[index + 1];
          const distanceToNext = nextStop
            ? calculateDistance(
                currentStop.latitude,
                currentStop.longitude,
                nextStop.latitude,
                nextStop.longitude,
              )
            : 0;

          return {
            ...currentStop,
            distanceToNext,
            order: String(index + 1), // Set order as a string here
          };
        })
        .filter(Boolean)
        .reverse()
        .reduce(
          (acc, current) => {
            if (current) {
              acc.push(
                current as TimeTableRow &
                  StationMetadata & { distanceToNext: number; order: string },
              );
            }
            return acc;
          },
          [] as (TimeTableRow &
            StationMetadata & { distanceToNext: number; order: string })[],
        );

      setStationsWithDistancesAndTimes(stationsWithDistances);
    };

    // Call the function to compute stations distances when dependencies change
    computeStationsWithDistances();
  }, [allStations, stationsMetadata]);

  const runStationFetchPipeline = async () => {
    if (fetchLockRef.current) return;
    fetchLockRef.current = true;

    const stationsToFetch = allStations.filter(
      (stop) => stop?.commercialStop && stop?.type === "ARRIVAL",
    );

    const uniqueStations = new Map();

    stationsToFetch.forEach((stop) => {
      uniqueStations.set(stop.stationShortCode, stop);
    });

    uniqueStations.forEach((stop) => {
      fetchStationPassingTrains(stop.stationShortCode, stop.scheduledTime);
    });

    setvaihtojunatHaettu(true);
  };

  useEffect(() => {
    if (!trainInfo?.timeTableRows?.length) return;
    if (!stationsMetadata.length) return;

    runStationFetchPipeline();
  }, [trainInfo?.trainNumber, stationsMetadata.length]);

  useEffect(() => {
    fetchLockRef.current = false;
    fetchedStationsRef.current = new Set();
    setvaihtojunatHaettu(false);
  }, [currentTrainNumber]);

  const createStationElements = () => {
    return stationsWithDistancesAndTimes.map((stop, index) => {
      if (!stop) {
        return null; // Check if stop is null
      }

      const stopMetadata = stationsMetadata.find(
        (station) => station.stationShortCode === stop.stationShortCode,
      );

      if (stopMetadata) {
        let distance = calculateLocationDistance(
          [location?.[0] ?? 0, location?.[1] ?? 0],
          [stopMetadata.longitude, stopMetadata.latitude],
        );

        // Get the stop rows corresponding to this station using the unique index
        let stopRows = groupedTimeTableRows.get(stop.stationShortCode) || [];

        const commercialStopRow = stopRows.find((row) => row.commercialStop);
        const validMapScale = mapScale ?? 10;
        const validHelperScale = helperScale ?? 22;
        const height = stop.distanceToNext * validMapScale; // 1 km = 10 px
        const rawBottomValue = distance * validMapScale - validHelperScale;
        let bottomValue = Math.min(Math.max(rawBottomValue, 0), height);

        if (speed === null) {
          bottomValue = 0;
        }

        // if (
        //   stop.commercialStop === true &&
        //   stop.type === "ARRIVAL" &&
        //   !vaihtojunatHaettu
        // ) {
        //   fetchStationPassingTrains(stop.stationShortCode, stop.scheduledTime);
        // }

        //console.log(JSON.stringify(stop, null, 2));

        return (
          <div
            key={`${stop.stationShortCode}-${stop.order}`}
            onClick={() => setFollowTrain(false)}
            style={{
              position: "relative",
              height: `${height}px`,
              border: "0px solid white",
              margin: "0px",
              display: "flex",
              alignItems: "end",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 48,
                height: "100%",
                width: stop.actualTime ? "9px" : "0",
                background: stop.actualTime
                  ? "linear-gradient(to right, rgba(255, 255, 255, 0.1) 0%, blue 50%, rgba(255, 255, 255, 0.1) 100%)"
                  : "transparent",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-32px",
                left: 65,
                width: 1,
                height: 10,
                backgroundColor: "gray",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: "-4px",
                  width: 9,
                  height: 6,
                  borderRadius: 1,
                  backgroundColor: "darkblue",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 4,
                }}
              >
                {stop.stationShortCode}
              </div>
            </div>
            {stop.type === "ARRIVAL" ||
              (trainInfo?.runningCurrently && (
                <div>
                  {trainInfo?.runningCurrently &&
                    currentStation === stop.stationShortCode && (
                      <div
                        className="d-flex"
                        id="current-location"
                        style={{
                          position: "absolute",
                          bottom: bottomValue,
                          left: "30px",
                          transform: "translateX(-50%)",
                          zIndex: 90,
                        }}
                        key="current-location"
                      >
                        {/* <div style={{ color: "white", marginLeft: 400 }}>
                      {distance}
                      </div> */}
                        <div
                          className="current-location-circle"
                          style={{
                            width: "40px",
                            height: "30px",
                            borderRadius: "50%",
                            backgroundColor: "transparent",
                            marginRight: "5px",
                          }}
                        />

                        <img
                          src={juna}
                          alt="Your location"
                          style={{ height: "86px" }}
                        />

                        {speed === 0 && speed !== null && (
                          <div
                            style={{ position: "absolute", height: "100px" }}
                          >
                            <img
                              src={redlight}
                              alt="stop"
                              style={{
                                height: "22px",
                                position: "absolute",
                                top: "-26px",
                                left: "62px",
                                transform: "translateX(-50%)",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                </div>
              ))}

            {commercialStopRow && (
              <div
                className="d-flex"
                key={stop.stationShortCode}
                id={stop.stationShortCode}
              >
                {stop.type === "ARRIVAL" && (
                  <div>
                    <div
                      className=""
                      style={{
                        position: "absolute",
                        color: "white",
                        marginTop: "-4px",
                      }}
                    >
                      <p
                        className="m-0"
                        style={{ lineHeight: "0.9", fontSize: 10 }}
                      >
                        {distance > 2000 ? "" : `${Math.round(distance)} km`}
                      </p>
                    </div>

                    <div
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "-3px",
                          left: 0,
                          backgroundColor: "rgba(173, 173, 173, 0.112)",
                          borderRadius: 4,
                          width: 42,
                          height: 86,
                          zIndex: 1,
                        }}
                      ></div>
                      <img
                        src={asema}
                        alt={`${stop} station`}
                        style={{
                          width: "40px",
                          height: "40px",
                          marginRight: "24px",
                          marginTop: 3,
                          position: "relative",
                          zIndex: 2,
                        }}
                      />

                      {speed === 0 && distance <= 0.8 && (
                        <div style={{ position: "absolute", height: "100px" }}>
                          <img
                            src={pponstation}
                            alt="stop"
                            style={{
                              height: "46px",
                              marginLeft: "20px",
                              marginTop: "-8px",
                              position: "relative",
                              zIndex: 3,
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div onClick={toggleZIndex}>
                  <div
                    style={{
                      position: "absolute",
                      backgroundColor: "white",
                      borderRadius: "4px",
                      boxShadow:
                        "2px -4px 5px rgba(0, 0, 0, 0.2), 2px -3px 16px rgba(0, 0, 0, 0.2)",
                      width: 220,
                      height: 35,
                      left: 66,
                      zIndex: 10,
                    }}
                  >
                    <div
                      style={{
                        padding: "4px",
                        marginTop: "-4px",
                        fontWeight: 900,
                        fontSize: 18,
                        textAlign: "left",
                        lineHeight: "1.0",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {typeof stop === "object" && stop !== null
                        ? stationNames[stop.stationShortCode] ||
                          stop.stationName
                        : stop}
                    </div>
                  </div>
                  <div
                    className="station"
                    style={{
                      position: "relative",
                      backgroundColor: "transparent",
                      borderRadius: "4px",
                      padding: "0px 1px 3px 2px",
                      margin: "8px 0",
                      marginTop: "-5px",
                      width: "fit-content",
                      lineHeight: "1.2",
                      left: stop.type === "DEPARTURE" ? "160px" : "0px",
                      zIndex: 12,
                    }}
                  >
                    <br />
                    {stop.type === "ARRIVAL" && (
                      <div className="arrivalRow ms-1">
                        <span>
                          <div className="raide-circle">
                            {stop.commercialTrack
                              ? `r${stop.commercialTrack}`
                              : null}
                          </div>{" "}
                          {new Date(stop.scheduledTime).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          })}
                          <span
                            className="font-small"
                            style={{
                              backgroundColor: stop.actualTime
                                ? new Date(stop.actualTime).toLocaleTimeString(
                                    [],
                                    {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: false,
                                    },
                                  ) <=
                                  new Date(
                                    stop.scheduledTime,
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })
                                  ? "green"
                                  : "rgb(211, 130, 146)"
                                : stop.liveEstimateTime
                                  ? "rgb(104, 104, 104)"
                                  : "transparent",
                              color: "white",
                              padding: "0px 2px",
                              borderRadius: "4px",
                              margin: "2px",
                            }}
                          >
                            {stop.actualTime
                              ? new Date(stop.actualTime).toLocaleTimeString(
                                  [],
                                  {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  },
                                )
                              : stop.liveEstimateTime
                                ? new Date(
                                    stop.liveEstimateTime,
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })
                                : null}
                          </span>
                        </span>
                      </div>
                    )}
                    {stop.type === "DEPARTURE" && (
                      <div className="departureRow ms-2">
                        <span>
                          {Array.from(groupedTimeTableRows.entries()).findIndex(
                            ([code]) => code === stop.stationShortCode,
                          ) === 0 && (
                            <div className="raide-circle">
                              {stop.commercialTrack
                                ? `r${stop.commercialTrack}`
                                : null}
                            </div>
                          )}
                          <strong>→</strong>{" "}
                          {new Date(stop.scheduledTime).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          })}
                          <span
                            className="font-small"
                            style={{
                              backgroundColor: stop.actualTime
                                ? new Date(stop.actualTime).toLocaleTimeString(
                                    [],
                                    {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: false,
                                    },
                                  ) <=
                                  new Date(
                                    stop.scheduledTime,
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })
                                  ? "green"
                                  : "rgb(211, 130, 146)"
                                : stop.liveEstimateTime
                                  ? "rgb(104, 104, 104)"
                                  : "transparent",
                              color: "white",
                              padding: "0px 2px",
                              borderRadius: "4px",
                              margin: "2px",
                            }}
                          >
                            {stop.actualTime
                              ? new Date(stop.actualTime).toLocaleTimeString(
                                  [],
                                  {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  },
                                )
                              : stop.liveEstimateTime
                                ? new Date(
                                    stop.liveEstimateTime,
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })
                                : null}
                          </span>
                        </span>
                      </div>
                    )}
                  </div>
                  {stop.type === "ARRIVAL" && (
                    <div className="">
                      {stationTrains[stop.stationShortCode] && (
                        <div
                          className="vaihtoyhteydet"
                          style={{
                            color: "white",
                            position: "absolute",
                            left: 72,
                            fontSize: 12,
                            marginTop: "-35px",
                            padding: "0px 4px 2px 0",
                            textAlign: "left",
                            backgroundColor: "#032938",
                            border: `2px solid rgba(30, 90, 114, 0.4)`,
                            borderRadius: 6,
                            zIndex: zIndex,
                          }}
                        >
                          <div className="ms-1" style={{ fontSize: 16 }}>
                            {stationNames[stop.stationShortCode]?.toUpperCase()}
                          </div>
                          {stationTrains[stop.stationShortCode].length > 0 ? (
                            stationTrains[stop.stationShortCode].map(
                              (train, index) => {
                                // Ehto, joka estää saman junan näyttämisen
                                if (
                                  trainInfo?.trainNumber !==
                                    train.trainNumber &&
                                  destinationStation !== train.vaihtoasema
                                ) {
                                  return (
                                    <div>
                                      {stop.stationShortCode === "PSL" &&
                                      train.destinationStation ===
                                        "HKI" ? null : (
                                        <div
                                          key={index}
                                          className="vaihtoasema-info d-flex"
                                          style={{
                                            color: "white",
                                            display: "flex",
                                            alignItems: "center",
                                            margin: 0,
                                          }}
                                        >
                                          <div
                                            className="ms-1"
                                            style={{ fontSize: 11 }}
                                          >
                                            {stop.stationShortCode}
                                          </div>
                                          <div
                                            className="vaihtoasema-info-type-number"
                                            onClick={() =>
                                              handleClickTrain(
                                                train.trainType,
                                                train.trainNumber,
                                                train.destinationStation,
                                              )
                                            }
                                            style={{
                                              textAlign: "right",
                                              margin: "1px 4px 1px 2px",
                                              padding: "0px 4px",
                                              cursor: "pointer",
                                              zIndex: 12,
                                              backgroundColor:
                                                "rgba(30, 90, 114, 0.4)",
                                              border: "none",
                                              borderRadius: 4,
                                              boxShadow:
                                                "1px 2px 2px rgba(0, 0, 0, 0.1)",
                                            }}
                                          >
                                            {train.trainType === "HL" ||
                                            train.trainType === "HLV"
                                              ? `${train.commuterLineID}`
                                              : `${train.trainType} ${train.trainNumber}`}
                                          </div>
                                          <div className="vaihtoasema-info-item">
                                            {
                                              stationNames[
                                                train.destinationStation
                                              ]
                                            }
                                          </div>

                                          {train.cancelled ? (
                                            <div
                                              className="vaihtoasema-info-item"
                                              style={{
                                                color: "rgb(211, 130, 146)",
                                              }}
                                            >
                                              <strong>Peruttu</strong>
                                            </div>
                                          ) : (
                                            <>
                                              <div className="raide-circle me-1">
                                                {train.commercialTrack || "N/A"}
                                              </div>
                                              <div className="me-1">
                                                {new Date(
                                                  train.scheduledTime,
                                                ).toLocaleTimeString("fi-FI", {
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                })}
                                              </div>
                                              {new Date(
                                                train.liveEstimateTime,
                                              ).getTime() -
                                                new Date(
                                                  train.scheduledTime,
                                                ).getTime() >
                                                120000 && (
                                                <div
                                                  className=""
                                                  style={{
                                                    color: "rgb(211, 130, 146)",
                                                  }}
                                                >
                                                  {new Date(
                                                    train.liveEstimateTime,
                                                  ).toLocaleTimeString(
                                                    "fi-FI",
                                                    {
                                                      hour: "2-digit",
                                                      minute: "2-digit",
                                                    },
                                                  )}
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  );
                                }
                                return null; // Jos juna on sama, ei palauta mitään
                              },
                            )
                          ) : (
                            <div></div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {showConfirm && (
                  <CustomConfirm
                    message={`Haluatko siirtyä junan ${moveToTrain} aikatauluun?`}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                  />
                )}
              </div>
            )}

            <div>
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  color: "gray",
                  fontSize: 9,
                  alignItems: "flex-end",
                  marginBottom: "12px",
                  marginRight: "-12px",
                  textAlign: "right",
                  lineHeight: "1",
                  maxWidth: 80,
                }}
              >
                {stop.type === "ARRIVAL" && (
                  <div style={{ marginBottom: "6px" }}>
                    <div style={{ marginBottom: "-6px" }}>
                      {stationNames[stop.stationShortCode]}
                    </div>
                  </div>
                )}
              </div>

              {showAddedCauses ? (
                <div
                  onClick={toggleInfo}
                  style={{
                    position: "fixed",
                    top: 90,
                    left: 0,
                    width: "100%",
                    maxWidth: 210,
                    color: "lightgray",
                    padding: "8px",
                    textAlign: "left",
                    fontSize: "14px",
                    lineHeight: "1.0",
                    height: "auto",
                    zIndex: 10,
                  }}
                >
                  <div>
                    {addedCauses.map((cause, index) => (
                      <div key={index}>{cause}</div>
                    ))}
                  </div>
                </div>
              ) : (
                <div>
                  {addedCauses && addedCauses.length > 0 && (
                    <div
                      onClick={toggleInfo}
                      style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "white",
                        backgroundColor: "darkblue",
                        position: "fixed",
                        top: "100px",
                        left: "12px",
                        width: "27px", // Pallon leveys
                        height: "27px", // Pallon korkeus
                        display: "flex", // Käytetään flexboxia keskittämiseen
                        justifyContent: "center", // Horisontaalinen keskittys
                        alignItems: "center", // Vertikaalinen keskittys
                        borderRadius: "50%", // Tekee siitä pyöreän
                        textAlign: "center",
                        zIndex: 10,
                      }}
                    >
                      i
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        );
      }
    });
  };

  const handleClickSeuraavaAsema = () => {
    setFollowTrain(false);
    if (nextStationShortCode) {
      const nextStationElement = document.getElementById(nextStationShortCode);
      if (nextStationElement) {
        nextStationElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } else {
        console.warn(`No element found with ID: ${nextStationShortCode}`);
      }
    } else {
      console.warn("stationShortCode is null.");
    }
  };

  const handleClicMinunAsema = () => {
    setFollowTrain(false);
    if (myDestination) {
      const myStationElement = document.getElementById(myDestination);
      if (myStationElement) {
        myStationElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } else {
        console.warn(`No element found with ID: ${myDestination}`);
      }
    } else {
      console.warn("stationShortCode is null.");
    }
  };

  const handleClickArrow = () => {
    setFollowTrain(false);
    goCurrentLocation();
  };

  const handleClickCurrentLocationFollow = () => {
    if (followTrain) {
      setFollowTrain(false);
    } else {
      setFollowTrain(true);
      goCurrentLocation();
    }
  };

  const goCurrentLocation = () => {
    const currentLocationElement = document.getElementById("current-location");
    if (currentLocationElement) {
      currentLocationElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    } else {
      console.warn("No element found for the current location.");
    }
  };

  useEffect(() => {
    if (followTrain) {
      const interval = setInterval(goCurrentLocation, 5000);
      return () => clearInterval(interval);
    }
  }, [followTrain]);

  useEffect(() => {
    const scrollToBottom = () => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    };
    let locationTimer: number | undefined;
    let scrollTimer: number | undefined;

    if (trainInfo?.runningCurrently) {
      locationTimer = window.setTimeout(() => {
        goCurrentLocation();
      }, 1000);
    } else {
      scrollTimer = window.setTimeout(() => {
        scrollToBottom();
      }, 900);
    }
    return () => {
      if (scrollTimer) {
        clearTimeout(scrollTimer);
      }
      if (locationTimer) {
        clearTimeout(locationTimer);
      }
    };
  }, [trainInfo?.runningCurrently]);

  useEffect(() => {
    if (trainInfo) {
      if (trainInfo.trainType === "HL" || trainInfo.trainType === "HLV") {
        setMapScale(100);
        setHelperScale(42);
      } else if (trainInfo.trainType === "HDM") {
        setMapScale(30);
        setHelperScale(34);
      } else if (
        trainInfo.trainType === "PYO" ||
        trainInfo.trainType === "IC" ||
        trainInfo.trainType === "S"
      ) {
        setMapScale(12);
        setHelperScale(38);
      } else {
        setMapScale(18);
        setHelperScale(34);
      }
    }
  }, [trainInfo]);

  useEffect(() => {
    // Etsi metadata-asema, joka vastaa määränpäätä
    const data = stationsMetadata.find(
      (station) => station.stationShortCode === myDestination,
    );

    if (data) {
      // Laske etäisyys ja aseta se stateen
      const distance = calculateLocationDistance(
        [location?.[0] ?? 0, location?.[1] ?? 0],
        [data.longitude, data.latitude],
      );

      setDistanceToMyDestination(Math.round(distance));
    }

    // Hae trainData timeTableRowsista rivi, jossa type on "ARRIVAL", stationShortCode on myDestination ja liveEstimateTime > nykyinen aika
    const currentTime = new Date();
    const arrivalRow = trainInfo?.timeTableRows?.find(
      (row) =>
        row.type === "ARRIVAL" &&
        row.stationShortCode === myDestination &&
        row.liveEstimateTime && // Tarkistetaan, että liveEstimateTime on määritelty
        new Date(row.liveEstimateTime) > currentTime, // Varmistetaan, että liveEstimateTime on tulevaisuudessa
    );

    if (arrivalRow && arrivalRow.liveEstimateTime) {
      const scheduledTime = new Date(arrivalRow.scheduledTime);
      const estimateTime = new Date(arrivalRow.liveEstimateTime);

      // Muotoile aika käyttämällä toLocaleTimeString
      const scheduledFormattedTime = scheduledTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
      const formattedTime = estimateTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      setScheduledTimeTimeToMyDestination(scheduledFormattedTime);
      setTimeToMyDestination(formattedTime);
    } else {
      // Aseta tyhjäksi, jos liveEstimateTime ei ole saatavilla
      setTimeToMyDestination("");
    }
  }, [myDestination, location, stationsMetadata, setDistanceToMyDestination]);

  const navigateTo = (path: string) => {
    navigate(path);
    setMenuOpen(false); // Close menu after navigation
  };

  const handleConsentSaveKaikki = () => {
    const consentData = {
      pakolliset: true,
      analytics: true,
      ads: true,
    };
    localStorage.setItem("cookieConsent", JSON.stringify(consentData));
    setCookiesWindow(false);
  };

  useEffect(() => {
    // Tarkista, kun beforeinstallprompt-tapahtuma laukaistaan
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault(); // Estää oletustoiminnan
      setDeferredPrompt(e); // Tallennetaan tapahtuma tilaan
      setShowInstallButton(true); // Näytetään asennusnappi
    };

    // Kuunnellaan beforeinstallprompt-tapahtumaa
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, []);

  useEffect(() => {
    // Asetetaan addedCauses tyhjäksi ennen uusien tietojen lisäämistä
    setAddedCauses([]);

    // Kerätään syyt ja lisätään ne addedCauses-tilaan
    const newCauses: string[] = [];

    stationsWithDistancesAndTimes.forEach((stop) => {
      if (!stop || !stop.causes) return;

      // Kerätään kaikki stop.causes ja lisätään aseman nimi
      const causesWithStationName = stop.causes.map((cause) => {
        const stationName =
          stationNames[stop.stationShortCode] || "Tuntematon asema";
        return `${stationName}: ${cause.detailedCategoryCode} - ${
          syyKoodit[cause.detailedCategoryCode]
        }`;
      });

      // Lisätään kerätyt syyt uuteen taulukkoon
      newCauses.push(...causesWithStationName);
    });

    // Jos uusi lista ei ole tyhjä, lisää "VIIVÄSTYKSET" alkuun
    if (newCauses.length > 0) {
      setAddedCauses(["VIIVÄSTYKSET", ...newCauses]);
    } else {
      setAddedCauses([]); // Tyhjennetään addedCauses, jos ei ole sisältöä
    }
  }, [trainInfo]);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    const promptEvent = deferredPrompt as any; // Tyypitetään tarvittaessa
    promptEvent.prompt(); // Näytetään asennuskehote

    // Odotetaan käyttäjän valintaa
    const choiceResult = await promptEvent.userChoice;
    if (choiceResult.outcome === "accepted") {
      console.log("User accepted the install prompt");
    } else {
      console.log("User dismissed the install prompt");
    }

    // Piilotetaan asennusnappi käytön jälkeen
    setDeferredPrompt(null);
    setShowInstallButton(false);
  };

  if (error) {
    return (
      <div>
        <div>{error}</div>
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "150px", marginBottom: "650px" }}
        >
          <div className="loader"></div>
        </div>
      </div>
    );
  }

  if (!trainInfo) {
    return (
      <div>
        <div>Loading...</div>
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "150px", marginBottom: "650px" }}
        >
          <div className="loader"></div>
        </div>
      </div>
    );
  }

  const filteredTimeTableRows = trainInfo.timeTableRows?.filter(
    (row) => row.commercialStop,
  );

  const groupedTimeTableRows = groupTimeTableRows(filteredTimeTableRows);

  return (
    <div>
      <Helmet>
        <meta property="og:title" content="Junasi aikataulut!" />
        <meta
          property="og:description"
          content="Katso junasi tämänhetkiset kulku- ja aikataulutiedot, vaihtoyhteydet sekä poikkeamat liikenteessä"
        />
        <meta
          property="og:image"
          content="https://minunjunani.fi/adimages/someshare.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://minunjunani.fi/adimages/someshare.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:url" content="https://minunjunani.fi" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div
        className="upperinfo"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: 70,
          width: "100%",
          backgroundImage: `url(${headerbg})`,
          backgroundSize: "cover",
          zIndex: 100,
          padding: "4px",
          boxShadow: "2px 2px 25px rgba(0, 0, 0, 0.9)",
          color: "white",
        }}
      >
        <div className="d-flex justify-content-between">
          <div
            className=""
            style={{
              borderRadius: "4px",
              padding: "0px 12px 4px 12px",
              margin: 0,
              width: "fit-content",
              height: "fit-content",
              boxShadow: "1px 0px 6px white",
              lineHeight: "0.4",
              backgroundColor: "#032938",
            }}
          >
            <h1 className="m-0">
              {trainInfo.trainType === "HL" || trainInfo.trainType === "HLV"
                ? trainInfo.commuterLineID
                : trainInfo.trainType}{" "}
              {trainInfo.trainNumber}
            </h1>
            <h2 className="font-small m-0">
              {departureStation && stationNames[departureStation]
                ? stationNames[departureStation]
                : departureStation}
              {" - "}
              {destinationStation && stationNames[destinationStation]
                ? stationNames[destinationStation]
                : destinationStation}
            </h2>
            <span className="m-0" style={{ lineHeight: "1.0", fontSize: 9 }}>
              Lähtöpäivä {formatDateOnlyDate(trainInfo.departureDate)}
            </span>
            <span className="font-small m-0">
              {trainInfo.runningCurrently ? "🚆" : ""}
            </span>

            <div
              style={{ marginTop: 4, marginBottom: 4, zIndex: 2 }}
              onClick={handleClickCurrentLocationFollow}
            >
              <span className="digital-clock m-0" style={{ fontSize: 16 }}>
                {speed !== null ? `${speed}` : ""}
              </span>

              <span className="font-small m-0 ms-1 me-2">km/h</span>
              {followTrain && (
                <span
                  style={{
                    fontSize: 11,
                    margin: "2px 0 0 0",
                    textShadow:
                      "2px 2px 5px rgba(255, 255, 255, 1), 1px 1px 2px rgba(255, 255, 255, 1), -2px -2px 3px rgba(255, 255, 255, 1)",
                    //transform: "rotate(-14deg)",
                    zIndex: 71,
                  }}
                >
                  Follow
                </span>
              )}
            </div>
          </div>

          <div style={{ marginTop: "-6px" }}>
            <div className="d-flex justify-content-between">
              <div className="me-2" style={{ textAlign: "right" }}>
                <div style={{ marginTop: "-12px" }}>
                  <p className="digital-clock m-0" style={{ fontSize: 48 }}>
                    {formattedCurrentTime}
                  </p>
                </div>
              </div>
              <div onClick={() => setMenuOpen(!menuOpen)}>
                <img
                  src={beefburgermenu}
                  alt="menu"
                  style={{ width: 28, margin: 10 }}
                />
              </div>
              {/* Slide-Down Menu */}
              {menuOpen && (
                <div
                  className="menu-overlay font-small"
                  style={{ lineHeight: "1.2", color: "lightgray" }}
                >
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      backgroundColor: "transparent",
                      zIndex: 70,
                    }}
                    onClick={() => setMenuOpen(false)}
                  ></div>
                  <div className="menu-content">
                    {/* Close Button */}
                    <div
                      className="menu-close"
                      onClick={() => setMenuOpen(false)}
                    >
                      <img
                        className="m-0"
                        src={beefburgermenuTumma}
                        alt="menu"
                        style={{ width: 28 }}
                      />
                    </div>

                    {/* Menu Items */}
                    <h3 className="mb-1">
                      {trainInfo.trainType === "HL"
                        ? trainInfo.commuterLineID
                        : trainInfo.trainType}{" "}
                      {trainInfo.trainNumber}
                    </h3>
                    <button
                      className="mb-2"
                      style={{ height: 50 }}
                      onClick={() => navigateTo("/set-train-number")}
                    >
                      🔍 Hae Juna
                    </button>

                    <div className="destination-dropdown">
                      <select
                        id="destination"
                        onChange={(e) => {
                          setMenuOpen(false);
                          setMyDestination(e.target.value);
                        }}
                        className="mb-3"
                      >
                        <option value="">Määränpääni</option>
                        {commercialStops.map((station) => (
                          <option key={station} value={station}>
                            {stationNames[station] || station}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* <button
                      className="m-0"
                      style={{ height: 50, fontSize: 9 }}
                      onClick={() => {
                        setMenuOpen(false);
                        setSeeTrafficPoints((prev) => !prev);
                      }}
                    >
                      Näytä liikennepaikat ja liikennetapahtumat
                    </button> */}
                    <div className="mt-5 mb-2">
                      <strong>Jaa kaverille junasi kulkutiedot!</strong>
                    </div>
                    <div
                      className="share-buttons mt-0 me-5 mb-4 p-0"
                      style={{
                        display: "flex",
                        gap: "10px",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      {/* Share on WhatsApp */}
                      <button
                        className="share-whatsapp"
                        style={{ flexGrow: 1, backgroundColor: "#25D366" }}
                        onClick={() => {
                          const message = "Minun junani kulkutiedot";
                          const url = window.location.href;
                          window.open(
                            `https://wa.me/?text=${encodeURIComponent(
                              message,
                            )} ${encodeURIComponent(url)}`,
                            "_blank",
                          );
                        }}
                      >
                        WhatsApp
                      </button>

                      {/* Share a Link */}
                      <button
                        onClick={handleCopyUrl}
                        className="share-buttons"
                        style={{ flexGrow: 1 }}
                      >
                        {copied ? "Linkki kopioitu" : "Jaa linkki"}
                      </button>
                    </div>

                    {showInstallButton && (
                      <div className="mt-5">
                        <div className="mb-1">Asenna sovellus laitteelle</div>
                        <div
                          onClick={handleInstallClick}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={pwaLogo}
                            alt="logo"
                            style={{
                              width: "24px",
                              height: "24px",
                              borderRadius: 4,
                              marginRight: 4,
                            }}
                          />
                          <strong>minunjunani</strong>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="menu-content-alareuna p-1">
                    <div
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        backgroundColor: "transparent",
                      }}
                    >
                      <img
                        src={someShare}
                        alt="add"
                        style={{
                          maxHeight: "360px",
                          maxWidth: "360px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div
              style={{ marginTop: "-14px", textAlign: "end", marginRight: 6 }}
            >
              <strong>{formattedDate}</strong>
            </div>
          </div>
        </div>
        <div>
          <div className="" style={{ marginTop: "-8px", textAlign: "left" }}>
            <strong className="m-0" style={{ color: "pink", fontSize: 28 }}>
              {trainInfo.cancelled ? "Juna on peruttu" : ""}
            </strong>
          </div>
          <div
            className="d-flex justify-content-between"
            style={{
              position: "relative",
              marginBottom: "-30px",
              marginLeft: "-12px",
            }}
          >
            {myDestination && (
              <div
                style={{
                  marginTop: 22,
                  zIndex: 2,
                  position: "absolute",
                  right: 0,
                }}
                onClick={handleClicMinunAsema}
              >
                <div
                  className="d-flex justify-content ms-4"
                  style={{
                    borderRadius: "4px",
                    paddingLeft: 10,
                    paddingTop: 2,
                    paddingRight: 10,
                    margin: "0 10px 0 0",
                    height: "52px",
                    boxShadow: "0px 0px 4px white",
                    backgroundColor: "#1e5a72",
                  }}
                >
                  {distanceToMyDestination != null &&
                  distanceToMyDestination < 4 ? (
                    <strong
                      className="pulsing-text"
                      style={{ marginTop: "-2px", fontSize: 20 }}
                    >
                      {stationNames[myDestination]}
                    </strong>
                  ) : (
                    <strong style={{ marginTop: "-2px", fontSize: 20 }}>
                      {stationNames[myDestination]}
                    </strong>
                  )}
                </div>
                <div
                  className="d-flex justify-content-between"
                  style={{
                    position: "relative",
                    left: 8,
                    marginTop: "-20px",
                    marginLeft: 22,
                    marginRight: 24,
                  }}
                >
                  {trainInfo?.runningCurrently &&
                    distanceToMyDestination &&
                    distanceToMyDestination < 2000 && (
                      <p className="font-small m-0 pe-4">
                        {distanceToMyDestination} km
                      </p>
                    )}
                  {timeToMyDestination && (
                    <div
                      className="d-flex shadow"
                      style={{
                        position: "relative",
                        top: "-10px",
                        color: "black",
                        backgroundColor: "white",
                        borderRadius: 4,
                        padding: "0 0 0 2px",
                        marginLeft: 8,
                        marginTop: 6,
                        alignItems: "flex-end",
                        lineHeight: 1.3,
                      }}
                    >
                      {scheduledTimeTimeToMyDestination}
                      <div
                        className="font-small"
                        style={{
                          color: "white",
                          backgroundColor: "rgb(104, 104, 104)",
                          borderRadius: 4,
                          padding: "0px 2px",
                          margin: "2px",
                          height: 16,
                        }}
                      >
                        {timeToMyDestination}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          className="passenger-information"
          style={{
            position: "fixed",
            bottom: 0,
            fontSize: 18,
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {/* {error && <div className="error">{error}</div>} */}
          {passengerInformation ? (
            passengerInformation
              .filter(
                (train) => train.trainDepartureDate === trainInfo.departureDate,
              ) // Suodatetaan junat oikean lähtöpäivämäärän mukaan
              .map((train) => (
                <div key={train.id} className="scrolling-text d-flex">
                  <div>{train.trainNumber} / </div>
                  <div>{train.videoTextFi} / </div>
                  <div>{train.videoTextSv} / </div>
                  <div>{train.videoTextEn}</div>
                </div>
              ))
          ) : (
            <div></div>
            // <div className="scrolling-text">
            //   Loading or no data availableLoading or no data availableLoading or
            //   no data availableLoading or no data available
            // </div>
          )}
        </div>

        <div
          className="sivunapit"
          style={{
            position: "fixed",
            bottom: "30px",
            right: "-10px",
            backgroundColor: "transparent",
            borderRadius: 12,
            width: 160,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          {mainosStation &&
            mainosStation.find(
              (ad) => ad.shortCode === nextStationShortCode,
            ) && (
              <div
                className="mainos-divi"
                id="add"
                style={{
                  padding: "4px 16px 4px 4px",
                  marginBottom: 40,
                  backgroundColor: "gray",
                  boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.6)",
                  borderRadius: 4,
                  width: 80,
                  height: "fit-content",
                  textAlign: "left",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: 50,
                }}
                key="advertisement"
              >
                <div className="mainostaulu" style={{}}>
                  {mainosStation
                    .filter((ad) => ad.shortCode === nextStationShortCode)
                    .map((ad) => (
                      <div
                        key={ad.shortCode}
                        style={{ lineHeight: "1.0", width: 60 }}
                      >
                        <div
                          style={{
                            fontSize: "10px",
                            fontWeight: "bold",
                            overflow: "hidden",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            marginBottom: 2,
                          }}
                        >
                          {ad.title}
                        </div>

                        <div
                          style={{
                            fontSize: "8px",
                            overflow: "hidden",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            marginBottom: 4,
                          }}
                        >
                          {ad.text}
                        </div>
                        <img
                          src={ad.image}
                          alt={`${ad.title} image`}
                          style={{
                            width: "100%",
                            height: "100%",
                            maxHeight: 120,
                            objectFit: "contain",
                            objectPosition: "center",
                            borderRadius: 4,
                          }}
                        />
                      </div>
                    ))}
                </div>
              </div>
            )}

          <div
            style={{
              padding: 2,
              backgroundColor: "#1e5a72",
              borderRadius: 12,
              width: "100%",
              marginBottom: 12,
              marginLeft: 50,
              boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.6)",
              textAlign: "left",
            }}
            onClick={handleClickArrow}
          >
            <img
              src={focusontrainarrow}
              alt="Focus on train"
              style={{
                height: 40,
                marginLeft: 30,
              }}
            />
          </div>
          <div
            style={{
              marginBottom: 12,
              marginLeft: 50,
              padding: "4px 18px 0px 6px",
              backgroundColor: "#1e5a72",
              boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.6)",
              borderRadius: 12,
              width: "100%",
              height: 90,
              textAlign: "left",
            }}
            onClick={handleClickSeuraavaAsema}
          >
            <p>
              <p className="m-0 font-small">
                {nextStationShortCode ? `Seuraavana ` : ""}
              </p>

              {stationLiveEstimateTime && (
                <div>
                  <p
                    className="m-0"
                    style={{
                      lineHeight: "0.9",
                      fontWeight: 700,
                    }}
                  >
                    {nextStationShortCode
                      ? `${stationNames[nextStationShortCode]} `
                      : ""}
                  </p>
                  <div
                    className="d-flex shadow"
                    style={{
                      color: "black",
                      backgroundColor: "white",
                      borderRadius: 4,
                      padding: 2,
                      marginLeft: 8,
                      marginTop: 6,
                      alignItems: "flex-end",
                    }}
                  >
                    {nextStationShortCode
                      ? `${
                          stationScheduledTime
                            ? new Date(stationScheduledTime).toLocaleTimeString(
                                [],
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                },
                              )
                            : ""
                        } `
                      : ""}
                    <div
                      className="font-small"
                      style={{
                        color: "white",
                        backgroundColor: "rgb(104, 104, 104)",
                        borderRadius: 4,
                        padding: "0px 2px",
                        margin: "2px",
                        height: 16,
                      }}
                    >
                      {nextStationShortCode
                        ? `${
                            stationLiveEstimateTime
                              ? new Date(
                                  stationLiveEstimateTime,
                                ).toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                })
                              : ""
                          }`
                        : ""}
                    </div>
                  </div>
                </div>
              )}
            </p>
          </div>
        </div>
        <div
          className="mainos"
          style={{
            position: "fixed",
            bottom: 30,
            left: "-12px",
            padding: "4px 4px 4px 16px",
            marginBottom: 12,
            backgroundColor: "#03334A",
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.6)",
            borderRadius: 4,
            width: 180,
            height: 90,
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
          // onClick={handleClickArrow}
        >
          {mainosStation &&
          mainosStation.find((ad) => ad.shortCode === "OIKEAALA") ? (
            <div
              className="mainostaulu"
              style={{
                width: "100%",
                maxHeight: 90,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              {mainosStation
                .filter((ad) => ad.shortCode === "OIKEAALA")
                .map((ad) => (
                  <div key={ad.shortCode} style={{ lineHeight: "1.0" }}>
                    {ad.title !== "" && (
                      <div
                        style={{
                          fontSize: "10px",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          marginBottom: 2,
                          paddingTop: 1,
                        }}
                      >
                        {ad.title}
                      </div>
                    )}
                    {ad.text !== "" && (
                      <div
                        style={{
                          fontSize: "8px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          marginBottom: 4,
                        }}
                      >
                        {ad.text}
                      </div>
                    )}
                    <img
                      src={ad.image}
                      alt={`${ad.title} image`}
                      style={{
                        width: "100%",
                        height: "auto",
                        maxWidth: "100%",
                        maxHeight: 80,
                        objectFit: "contain",
                        borderRadius: 4,
                      }}
                    />
                  </div>
                ))}
            </div>
          ) : (
            <img
              src={someShare}
              alt="Focus on train"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          )}
        </div>
      </div>
      <div style={{ height: 20 }}></div>

      <div
        className="matka"
        style={{ position: "relative", marginTop: "140px" }}
      >
        {createStationElements()}
      </div>
      <div style={{ height: 260 }}></div>
      {cookiesWindow && (
        <div
          style={{
            position: "fixed", // Aseta elementti kiinteäksi
            top: 0, // Aseta yläreuna
            left: 0, // Aseta vasen reuna
            width: "100%", // Ota koko leveys
            height: "100%", // Ota koko korkeus
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            zIndex: 9999, // Varmista, että se on päällä muista elementeistä
          }}
        >
          <div
            className=""
            style={{
              backgroundColor: "white", // Valkoinen taustaväri
              borderRadius: 12, // Pyöristetyt kulmat
              position: "absolute", // Aseta suhteellisesti
              bottom: 60, // Aseta 20px ylös näytön alareunasta
              left: "50%", // Keskitetään vaakasuunnassa
              transform: "translateX(-50%)", // Siirrä vasemmalle, jotta se on keskitetty
              padding: 20, // Lisää tilaa sisältöön
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)", // Lisää varjoa
              textAlign: "start",
            }}
          >
            <h3 className="">Evästeet</h3>
            <p>
              Sovelluksemme käyttää evästeitä ja vastaavia seurantatekniikoita
              käyttäjäkokemuksen parantamiseksi, sivuston käytön analysoimiseksi
              sekä personoitujen mainosten näyttämiseksi Googlen mainosten ja
              analytiikan avulla.
            </p>

            <div>
              <div className="mb-4">
                <p style={{ marginRight: "4px", margin: 0 }}>
                  Lisätietoja löydät{" "}
                </p>
                <Link
                  to="/privacy-policy"
                  className="nav-link"
                  style={{ color: "#1e5a72" }}
                >
                  Tietosuojakäytännöstömme
                </Link>
              </div>
              <div className="">
                <button
                  style={{
                    width: "fit-content",
                    height: "fit-content",
                    padding: 8,
                    backgroundColor: "green",
                    color: "lightgray",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "8px",
                    borderRadius: "5px",
                    border: "none",
                    cursor: "pointer", // Change cursor to pointer
                    boxShadow: "2px 2px 12px rgba(0, 0, 0, 0.6)",
                  }}
                  onClick={() => handleConsentSaveKaikki()}
                >
                  Hyväksy kaikki evästeet
                </button>
                <p></p>
                <button
                  style={{
                    width: "fit-content",
                    height: "fit-content",
                    padding: 8,
                    backgroundColor: "#1e5a72",
                    color: "lightgray",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "8px",
                    borderRadius: "5px",
                    border: "none",
                    cursor: "pointer", // Change cursor to pointer
                    boxShadow: "2px 2px 12px rgba(0, 0, 0, 0.6)",
                  }}
                  onClick={() => navigate("/cookies")}
                >
                  Evästeasetukset
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainInfo;
